var _style, _defs, _path, _path2, _path3, _g, _defs2, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSaniqAppLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 258 258",
  style: {
    enableBackground: "new 0 0 258 258"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".saniq_app_light_svg__st88{fill:#126c91}.saniq_app_light_svg__st90,.saniq_app_light_svg__st91{opacity:.55;fill:#95c2e5}.saniq_app_light_svg__st91{opacity:.39}.saniq_app_light_svg__st92{fill:#93c2e3}")), /*#__PURE__*/React.createElement("g", {
  id: "saniq_app_light_svg__svg5"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff"
  },
  d: "M-1.9-7.9h266.3v283.3H-1.9z"
}), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "saniq_app_light_svg__path821_00000127012219178219814990000016587251904444004764_",
  d: "M-278 0h258v258h-258V0z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "saniq_app_light_svg__path821_00000023989079097760560730000010202990056076929947_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#saniq_app_light_svg__path821_00000127012219178219814990000016587251904444004764_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#saniq_app_light_svg__path821_00000023989079097760560730000010202990056076929947_)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st90",
  d: "M111 91c-28.6-8.6-77.1-12.6-133.9 10.3-77.8 31.4-108.2 48.4-227-10C-320.4 56.7-375.5 58-400 61.2V143c67.5-36.3 115.9-13.4 203.9 11 84.9 23.5 128.4-22.5 184.2-51.2C35.2 78.6 83.4 85.6 111 93.2V91z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st91",
  d: "M111 81c-178.9-18-209.3 59.6-309.7 56.3-59.4-2-84.4-21.1-129.5-31.9-32.3-7.7-57.4-3-71.8 1.7v4c71.6-29.4 111.4 36 200.8 47.5C-131.6 167.3-24.5 118 19 116c42.2-2 75.9 14.1 92.1 30.5V81z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st92",
  d: "M111 91.8C75 79.3 35.7 74.5-3 74.6c-100.6.3-194.7 43.2-292.8 56.5-39.6 5.4-73.6 6.9-104.2 5.8v7.9c48.5 2.2 97.1 0 144.8-6.7 50.2-7.1 99.1-19 148.6-28.5 69.9-13.4 147.6-21.9 217.6-4V91.8z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "saniq_app_light_svg__layer1_00000142136539583863986210000009311936246149935513_",
  transform: "translate(-64.941 -78.149)"
}, /*#__PURE__*/React.createElement("path", {
  id: "saniq_app_light_svg__path821_00000137832712155125135020000012975489001236800640_",
  className: "saniq_app_light_svg__st88",
  d: "M202.9 286.7c11.1-1.4 21.3-4.9 30.6-10.4 2.8-1.7 2.6-1.6 3.5-.7 13 13.7 39.5 14.6 39.5 1.4 0-3.3 0-3.3-11.9-14.7-4.8-4.6-7.4-7.2-7.3-7.4.1-.2.9-1.4 1.9-2.8 35.9-53.1-2.2-125-66.2-125-58.1 0-96.7 60-72.8 113.2 12 26.6 37.2 44.1 67.4 46.8 2.4.3 12.5 0 15.3-.4zm26.2-19.5c-8.4-8.2-7.5-7.8-12.1-5.9-40 17-83-11.2-83-54.4 0-49.2 56.6-76.7 95.6-46.5 23 17.8 29.5 51.1 14.9 76.1-1.5 2.6-1.6 2.9-1.6 4.2v1.4l6.6 6.5c3.6 3.6 6.6 6.6 6.6 6.7 0 .9-8.3 9.7-12.3 13-2.7 2.3-7.3 5.6-7.7 5.6 0 0-3.2-3-7-6.7z"
}))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "saniq_app_light_svg__path821_00000093873881338651409730000005680537476893618829_",
  d: "M-.2-.1h257.9v257.9H-.2V-.1z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "saniq_app_light_svg__path821_00000030466448424576187400000017142278415056979105_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#saniq_app_light_svg__path821_00000093873881338651409730000005680537476893618829_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#saniq_app_light_svg__path821_00000030466448424576187400000017142278415056979105_)"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st90",
  d: "M388.9 91c-28.6-8.6-77.1-12.6-133.9 10.3-77.8 31.4-108.2 48.4-227-10C-42.4 56.7-97.6 58-122.1 61.2V143c67.5-36.3 115.9-13.4 203.9 11 84.9 23.5 128.4-22.5 184.2-51.2 47.1-24.2 95.4-17.3 122.9-9.6V91z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st91",
  d: "M388.9 81c-178.8-18-209.3 59.6-309.7 56.3-59.4-2-84.4-21.1-129.5-31.9-32.3-7.7-57.4-3-71.8 1.7v4c71.6-29.4 111.4 36 200.8 47.5 67.6 8.7 174.7-40.6 218.2-42.6 42.2-2 75.9 14.1 92.1 30.5V81z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "saniq_app_light_svg__st92",
  d: "M388.9 91.8c-35.9-12.5-75.2-17.3-114-17.2-100.6.3-194.7 43.2-292.8 56.5-39.6 5.4-73.6 6.9-104.2 5.8v7.9c48.5 2.2 97.1 0 144.8-6.7 50.2-7.1 99.1-19 148.6-28.5 69.9-13.4 147.6-21.9 217.6-4V91.8z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "saniq_app_light_svg__layer1_00000000184959334797055880000014426887594013207731_",
  transform: "translate(-64.941 -78.149)"
}, /*#__PURE__*/React.createElement("path", {
  id: "saniq_app_light_svg__path821_00000047058081465115306260000009976459369850978218_",
  className: "saniq_app_light_svg__st88",
  d: "M187.6 287c2.4.2 12.4-.1 15.3-.4 11.1-1.4 21.3-4.9 30.6-10.4 2.8-1.7 2.6-1.6 3.5-.7 13 13.7 39.5 14.6 39.5 1.4 0-3.3 0-3.3-11.9-14.7-4.8-4.6-7.4-7.2-7.3-7.4.1-.2.9-1.4 1.9-2.8 35.9-53.1-2.2-125-66.2-125l36.7 33.2c23 17.8 29.5 51.1 14.9 76.1-1.5 2.6-1.6 2.9-1.6 4.2v1.4l6.6 6.5c3.6 3.6 6.6 6.6 6.6 6.7 0 .9-8.3 9.7-12.3 13-2.7 2.3-7.3 5.6-7.7 5.6-.1 0-3.3-3-7.1-6.7-8.4-8.2-7.5-7.8-12.1-5.9L187.6 287z"
})))));
export { SvgSaniqAppLight as ReactComponent };
export default __webpack_public_path__ + "f679971af32115c62964bf18b3b063a6.svg";